import {
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  Select,
} from '@material-ui/core';

import React, { useEffect, useMemo, useState } from 'react';
import useUserInfo from 'src/hooks/user/use-user-info';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  branchLabel?: string;
  disabled?: boolean;
  allowNoSelectedBranch?: boolean;
  multiple?: boolean;
  defaultValue?: number[];
  paperSpace?: string | number;
  isElevated?: boolean;
  size?: 'small' | 'medium' | undefined;
  resetValue?: boolean;
  limitTags?: number;

  //this will return branch ids
  onHandleBranchChange: (branchIds?: number[]) => void;
  onHandleFocus?: () => void;
  onResetComplete?: () => void;
}

const component = ({
  defaultValue,
  branchLabel = 'Branch',
  allowNoSelectedBranch = true,
  disabled = false,
  multiple = false,
  resetValue = false,
  paperSpace = '10px',
  isElevated = true,
  size,

  onHandleBranchChange,
  onHandleFocus,
  onResetComplete
}: Props) => {
  const { userBranchOptions } = useUserInfo();
  const [noSelectedBranch, setNoSelectedBranch] = useState<boolean>(false);

  const defaultValueBranch = useMemo(() => {
    let branchNames: string[] = [];

    if (defaultValue) {
      branchNames = userBranchOptions
        .filter((branch) => defaultValue.includes(branch.value))
        .map((branch) => branch.name);
    }

    return branchNames;
  }, [defaultValue, userBranchOptions]);

  const [selectedBranchName, setSelectedBranchName] = useState<string[]>([]);

  const handleChange = (event?: React.ChangeEvent<{ value: any }>) => {
    const selectedValue = event?.target.value;

    const branchIds = userBranchOptions
      .filter((branch) => selectedValue.includes(branch.name))
      .map((branch) => branch.value);

    //We are sure about the string
    if (selectedValue === `No Selected Branch` && allowNoSelectedBranch) {
      setNoSelectedBranch(true);
    } else {
      setNoSelectedBranch(false);
    }

    setSelectedBranchName(selectedValue);
    onHandleBranchChange(branchIds);
  };

  const handleClear = () => {
    setSelectedBranchName([]);
    setNoSelectedBranch(false);
    onHandleBranchChange([]);
  };

  useEffect(() => {
    setSelectedBranchName(defaultValueBranch);
  }, [defaultValueBranch]);

  useEffect(() => {
    if (resetValue) {
      setSelectedBranchName(defaultValueBranch);
      setNoSelectedBranch(false);
      onResetComplete?.();
    }
  }, [defaultValueBranch, onHandleBranchChange, onResetComplete, resetValue]);

  const RenderBranchDropdown = () => {
    if (multiple) {
      return (
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="branch-checkbox-label">Branch</InputLabel>
          <Select
            disabled={disabled}
            labelId="branch-checkbox-label"
            id="branch-checkbox"
            multiple
            value={selectedBranchName}
            onChange={handleChange}
            onFocus={onHandleFocus}
            renderValue={(selected: any) => selected.join(', ')}
            label="Branch"
            input={
              <OutlinedInput
                label={branchLabel}
                endAdornment={
                  selectedBranchName ? (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="clear selection"
                        onClick={handleClear}
                        edge="end"
                        style={{ marginRight: '5px' }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  ) : null
                }
              />
            }
          >
            {userBranchOptions
              ? userBranchOptions?.map((options) => (
                  <MenuItem key={options?.value} value={options?.name}>
                    <Checkbox
                      checked={selectedBranchName.includes(options?.name)}
                    />
                    {options?.name}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
      );
    } else {
      return (
        <Paper
          style={{
            padding: paperSpace
          }}
          elevation={isElevated ? 1 : 0}
        >
          <FormControl size={size} variant="outlined" fullWidth>
            <InputLabel id="branch-dropdown">{branchLabel}</InputLabel>
            <Select
              disabled={disabled}
              labelId="branch-dropdown"
              id="dropdown-select"
              value={selectedBranchName}
              onChange={handleChange}
              label={branchLabel}
              renderValue={(selected: any) => selected}
              //optionals
              onFocus={onHandleFocus}
              input={
                <OutlinedInput
                  label={branchLabel}
                  endAdornment={
                    selectedBranchName ? (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear selection"
                          onClick={handleClear}
                          edge="end"
                          style={{ marginRight: '5px' }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }
                />
              }
            >
              {allowNoSelectedBranch && (
                <MenuItem value={'No Selected Branch'}>
                  <Radio checked={noSelectedBranch} />
                  {'No Selected Branch'}
                </MenuItem>
              )}

              {userBranchOptions
                ? userBranchOptions?.map((options) => (
                    <MenuItem key={options.value} value={options?.name}>
                      <Radio
                        checked={selectedBranchName.includes(options.name)}
                      />
                      {options?.name}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        </Paper>
      );
    }
  };

  return <div>{userBranchOptions ? <RenderBranchDropdown /> : null}</div>;
};
//TODO:remove on develop
export const BranchListDropDown = React.memo(component);
